import { BuyPopupProps } from '@/components/mobile/BuyPopup'
import { ContactPopupProps } from '@/components/mobile/ContactPopup'
import { LoginDialogProps } from '@/components/mobile/LoginDialog/LoginDialog'
import { PayingPopupProps } from '@/components/mobile/PayingPopup'
import { PaySuccessPopupProps } from '@/components/mobile/PaySuccessPopup'
import { PackageExpiredPopupProps } from '@/components/mobile/PackageExpiredPopup/PackageExpiredPopup'
import { DownloadProgressPopupProps } from '@/components/mobile/DownloadProgressPopup/DownloadProgressPopup'
import { action, makeObservable, observable, runInAction } from 'mobx'
import eruda from 'eruda'
import { commonUtils } from '@/helpers/commonUtils'
import { LoginModalProps } from '@/components/pc/LoginModal/LoginModal'
import { PaySuccessModalProps } from '@/components/pc/PaySuccessModal/PaySuccessModal'
import { PayModalProps } from '@/components/pc/PayModal/PayModal'
import { DownloadDialogProps } from '@/components/pc/DownloadDialog'
import { PackageExpiredModalProps } from '@/components/pc/PackageExpiredModal/PackageExpiredModal'
import emitter, { MobileEmitterEvents, PcEmitterEvents } from '@/helpers/emitter'
import { MessageInstance } from 'antd/es/message/interface'
import { PcLoginDecorator, MobileLoginDecorator } from '@/helpers/decorator'
import { routerService } from '@/services/routerService'
import { CustomerServiceModalProps } from '@/components/pc/CustomerServiceModal'
import { DownloadProgressModalProps } from '@/components/pc/DownloadProgressModal/DownloadProgressModal'
import { api } from '@/helpers/api'
import { userService } from '@/services/userService/userService'
import { getBiluEntryPayload } from '@/components/mobile/useWechatBiluLaunchInfo'
import type { BiluEntryType } from '@/helpers/api/user'

class UiController {
  @observable message!: MessageInstance

  @observable test = false

  // 移动端浏览器引导遮罩
  @observable browserGuideMaskVisible = false

  @action
  showBrowserGuideMask() {
    this.browserGuideMaskVisible = true
  }

  @action
  hideBrowserGuideMask() {
    this.browserGuideMaskVisible = false
  }

  // 移动端购买弹窗
  @observable buyPopupProps: BuyPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.buyPopupProps.visible = false
      })
    },
  }

    // 客服弹窗
  @observable customerServiceModalProps: CustomerServiceModalProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.customerServiceModalProps.visible = false
      })
    },
  }

  // 移动端支付弹窗
  @observable payingPopupProps: PayingPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.payingPopupProps.visible = false
      })
    },
  }

  // 移动端支付成功弹窗
  @observable paySuccessPopupProps: PaySuccessPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.paySuccessPopupProps.visible = false
      })
    },
  }

  @action
  openPaySuccessPopup(download: boolean | (() => void) = false) {
    this.paySuccessPopupProps.visible = true
    this.paySuccessPopupProps.onDownload = download
  }

  // 移动端套餐过期弹窗
  @observable packageExpiredPopupProps: PackageExpiredPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.packageExpiredPopupProps.visible = false
      })
    },
    onContact: false,
  }

  @observable mobileDownloadProgressPopupProps: DownloadProgressPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.mobileDownloadProgressPopupProps.visible = false
      })
    },
  }

  // 移动端联系客服弹窗
  @observable contactPopupProps: ContactPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.contactPopupProps.visible = false
      })
    },
  }

  // 领取课件二维码
  @observable downloadConsultationQrCodePopupProps: ContactPopupProps = {
    visible: false,
    title: '领取课件',
    description: '添加客服领取课件～',
    onClose: () => {
      runInAction(() => {
        this.downloadConsultationQrCodePopupProps.visible = false
      })
    },
  }

  // 移动端登录弹窗
  @observable loginDialogProps: LoginDialogProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.loginDialogProps.visible = false
      })
    },
    onLoginSuccess: () => {
      emitter.emit(MobileEmitterEvents.MOBILE_LOGIN_SUCCESS)
      runInAction(() => {
        this.loginDialogProps.visible = false
      })
    },
  }

  public init() {
    makeObservable(this)
      if ((window.location.host === 'homesite.sparkglow.cn' && commonUtils.isMobile()) ||(userService?.userId === '4252773686' || userService?.userId === '7985066341')) {
          eruda.init()
        }
    }
  // PC端登录弹窗
  @observable PcLoginModalProps: LoginModalProps = {
    visible: false,
    type: 'login',
    onClose: () => {
      runInAction(() => {
        this.PcLoginModalProps.visible = false
      })
    },
    onLoginSuccess: () => {
      emitter.emit(PcEmitterEvents.PC_LOGIN_SUCCESS)
      runInAction(() => {
        this.PcLoginModalProps.visible = false
      })
    },
  }

  // PC端支付成功弹窗
  @observable PcPaySuccessModalProps: PaySuccessModalProps = {
    visible: false,
    goodsName: '',
    onDownload: function (): void {
      throw new Error('Function not implemented.')
    },
    onClose: () => {
      runInAction(() => {
        this.PcPaySuccessModalProps.visible = false
      })
    },
  }

  // PC 端支付弹窗
  @observable PcPayModalProps: PayModalProps = {
    visible: false,
    goodsDetail: undefined,
    onPaySuccess: function (goodsName: string): void {
      throw new Error('Function not implemented.')
    },
    onClose: () => {
      runInAction(() => {
        this.PcPayModalProps.visible = false
      })
    },
  }

  // PC 端下载弹窗
  @observable PcDownloadDialogProps: DownloadDialogProps = {
    visible: false,
    materials: [],
    goodsName: '',
    hasUnitChapter:false,
    total:0,
    onClose: () => {
      runInAction(() => {
        this.PcDownloadDialogProps.visible = false
        this.PcDownloadDialogProps.materials = []
        this.PcDownloadDialogProps.goodsName = ''
        this.PcDownloadDialogProps.hasUnitChapter = false
        this.PcDownloadDialogProps.total = 0
      })
    },
  }

  // PC 端套餐过期弹窗
  @observable PcPackageExpiredModalProps: PackageExpiredModalProps = {
    visible: false,
    onContact: () => {},
    onClose: () => {
      runInAction(() => {
        this.PcPackageExpiredModalProps.visible = false
      })
    },
  }

  @observable PcDownloadProgressModalProps: DownloadProgressModalProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.PcDownloadProgressModalProps.visible = false
      })
    },
  }

  //
  @PcLoginDecorator()
  opneJBAI() {
    routerService.navigateTo('pcJBAI')
  }

  @PcLoginDecorator()
  async openBiluSso(
    scene: 'pc_web' | 'wechat_h5' | 'mobile_browser' = 'pc_web',
    position:string,
    entry: BiluEntryType = 'home'
  ): Promise<void> {
    const response = await api.user.getBiluSsoEntry(scene, entry)
    const targetUrl =response.data.url
    if (targetUrl) {
      window.open(targetUrl,'_blank')
         userService.postUserActionRecord({
          module: 'PC端官网',
          function: '跳转到笔鹿作文官网',
          position,
          action: '点击',
          element: '轮播图',
        })
    }
  }


 async openMobileBiluSso(source: BiluEntryType,position:string): Promise<void> {
    const scene = commonUtils.isWechat() ? 'wechat_h5' : 'mobile_browser'
    const payload = await getBiluEntryPayload(scene, source)
    const targetUrl = payload?.url
    if (targetUrl) {
      userService.postUserActionRecord({
        module: '移动端官网',
        function: '跳转到笔鹿作文小程序',
        position,
        action: '点击',
        element: '确认跳转',
        remark: { source, scene },
      })
      window.location.href = targetUrl
    }
  }

    @MobileLoginDecorator()
    async navigateTBilu(source: BiluEntryType,position:string): Promise<void> {
      await this.openMobileBiluSso(source,position)
    }


     @MobileLoginDecorator()
    async navigateTBiluNew(source: BiluEntryType,position:string): Promise<void> {
        const scene = 'mobile_browser'
        const payload = await getBiluEntryPayload(scene, source)
        const targetUrl = payload?.url
        if (targetUrl) {
          userService.postUserActionRecord({
            module: '移动端官网',
            function: '跳转到笔鹿作文小程序',
            position,
            action: '点击',
            element: '确认跳转',
            remark: { source, scene },
          })
          window.location.href = targetUrl
        }
    }


}

export const uiController = new UiController()
